<div class="modal-header">
  <div class="d-flex align-items-center gap-2">
    <h5 *ngIf="isEdit" class="modal-title">
      <i class="far fa-box-up"></i><ng-container>&nbsp;</ng-container
      ><ng-container i18n>Edit Min Stay Automation</ng-container>
    </h5>
    <h5 *ngIf="!isEdit" class="modal-title">
      <i class="far fa-box-up"></i><ng-container>&nbsp;</ng-container
      ><ng-container i18n>Add Min Stay Automation</ng-container>
    </h5>
    <app-page-help articleId="zp1i1aei14"></app-page-help>
  </div>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>
<div class="modal-body bg-none p-0">
  <form [formGroup]="form" (submit)="onSubmit(form)" [formEditablePermission]="form">
    <div class="container-box p-3">
      <div class="row">
        <div class="col-lg-6">
          <mat-form-field2 class="mat-block">
            <input type="text" i18n-placeholder placeholder="Name" matInput formControlName="name" required />
            <mat-error *ngIf="form.get('name').touched && form.get('name').hasError('required')" i18n>
              Name is required
            </mat-error>
            <mat-error *ngIf="form.get('name').hasError('allNumbers')" i18n> Name cannot be numbers alone </mat-error>
          </mat-form-field2>
        </div>
        <div class="col-lg-6">
          <mat-form-field2 i18n-matTooltip matTooltip="This automation will apply to only selected dates">
            <app-mat-daterange-input
              placeholder="Date Range"
              i18n-placeholder
              formControlName="range"
              [minDate]="minDate"
              [required]="true"
              [showQuickActions]="false"
              [ranges]="usedRange$ | async"
            ></app-mat-daterange-input>
            <mat-error *ngIf="form.get('range').touched && form.get('range').hasError('required')" i18n>
              Date Range is required
            </mat-error>
            <mat-error *ngIf="form.get('range').hasError('overlap')" i18n>
              Date Range is overlapping with other automation
            </mat-error>
          </mat-form-field2>
        </div>
        <div class="col-lg-6">
          <app-rental-select
            [ctrl]="form.get('rentals')"
            [excludeSubunits]="true"
            placeholder="Rentals"
            i18n-placeholder
            i18n-matTooltip
            matTooltip="Select Rental you want the min nights automation to apply to"
          >
          </app-rental-select>
        </div>
      </div>
    </div>

    <div class="container-box p-3 mt-3">
      <div class="row">
        <div class="col-lg-3" *ngFor="let item of daysForm.controls; let i = index">
          <mat-form-field2
            class="mat-block"
            i18n-matTooltip
            matTooltip="The minimum nights requirement for the booking that starts on selected day"
          >
            <mat-label>{{ weekdayOptions[i] }}</mat-label>
            <input matInput i18n-placeholder type="number" [formControl]="item" placeholder="Min Nights" />
            <mat-error *ngIf="item.touched && item.hasError('required')" i18n> Min nights is required </mat-error>
            <mat-error *ngIf="item.hasError('positive') || item.hasError('integer')" i18n>
              Min nights should be positive integer
            </mat-error>
          </mat-form-field2>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-light">
    <i class="far fa-times"></i> <ng-container i18n>Cancel</ng-container>
  </button>
  <button
    (click)="onSubmit(form)"
    [disabled]="form.disabled || (1 | isReadonlyRole)"
    type="button"
    class="btn btn-secondary-info create-btn"
  >
    <i *ngIf="!form.disabled" class="cs-icon cs-icon-save"></i>
    <i *ngIf="form.disabled" class="far fa-spinner fa-spin"></i>
    <ng-container i18n>Save</ng-container>
  </button>
</div>
